// Author liang gang qiang
// Date 2021-11-22 12:04:32

import * as model from "@/model/mintalMes/prd/MintalMesPrdShiftHandoverModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdShiftHandover(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
